'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import Sidebar from 'ContentEditorUI/components/sidebar/Sidebar';
import AppReadyContainer from 'ContentEditorUI/containers/AppReadyContainer';
import { getActiveSidebarPanel, getIsSidebarExpanded } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  activePanel: getActiveSidebarPanel(state),
  isOpen: getIsSidebarExpanded(state),
  isReadOnlyMode: getIsReadOnlyMode(state)
});

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children (required)
 * @param {string} props.activePanel (required)
 * @param {boolean} props.isOpen (required)
 * @param {boolean} props.isReadOnlyMode (required)
 * @param {React.ReactNode} [props.headerLabel] (optional)
 */
class SidebarContainer extends Component {
  render() {
    const {
      activePanel,
      children,
      isOpen,
      isReadOnlyMode,
      headerLabel
    } = this.props;
    return /*#__PURE__*/_jsx(AppReadyContainer, {
      children: /*#__PURE__*/_jsx(Sidebar, {
        isOpen: isOpen,
        activePanel: activePanel,
        isReadOnlyMode: isReadOnlyMode,
        headerLabel: headerLabel,
        children: children
      })
    });
  }
}
export default connect(mapStateToProps)(SidebarContainer);